import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoHeader } from '../core';

const DialogRequestTypeHeader = ({ requestTypeName }) => {
    const { t: tApproval } = useTranslation('employmentBillboard', { keyPrefix: 'dialog' });
    const { t: tRequestType } = useTranslation('employmentBillboard', { keyPrefix: 'requestType' });
    return (
        <InfoHeader
            header={tApproval('requestType')}
            subheader={tRequestType(requestTypeName)}
        />
    );
};

export default DialogRequestTypeHeader;
